<template>
  <v-layout row wprap>
    <v-flex xs6 py-4 pl-4 pr-2 style="position:relative;" >
      <v-card class="ml-3 my-3 maincontent" >        
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >
            <span class="subheading" style="flex:0 0 auto;">{{$t('Pilot.MapLayer.LinkExistingLayer')}}</span>
            <v-autocomplete style="flex:0 0 auto;"
              :items="existingLayers"
              item-text="LAY_LIBELLE"
              item-value="LAY_ID"
              :label="$t('Pilot.MapLayer.ExistingLayers')"
              v-model="newExistingId"
              append-outer-icon="mdi-plus" @click:append-outer="addNewExistingLayer()"
            ></v-autocomplete> 
            <div class="pb-2" >
                <v-chip v-for="layer in existingMissionLayers" :key="layer.id" close @input="removeExistingLayer(layer)">{{layer.libelle}}</v-chip>
            </div>
        </v-card-title>                    
      </v-card>      
    </v-flex>    
    <v-flex xs6 py-4 pr-4 pl-2 style="position:relative;" >
      <v-card class="ml-2 mr-3 my-3 maincontent" >
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >
            <span class="subheading" style="flex:0 0 auto;">{{$t('Pilot.MapLayer.CustomLayer')}}</span>                                                              
            <v-btn @click="addNewCustomLayer()">{{$t('Pilot.MapLayer.AddNewCustomLayer')}} <v-icon right>mdi-plus</v-icon></v-btn>
            <div class="pb-2" >
              <v-chip v-for="layer in customMissionLayers" :key="layer.id">
                {{layer.libelle}}
                <div class="v-chip__close"><v-icon @click.stop.prevent="editCustomLayer(layer)" small right>mdi-pencil</v-icon></div>
                <div class="v-chip__close"><v-icon @click.stop.prevent="deleteCustomLayer(layer)" small right>mdi-delete</v-icon></div>
              </v-chip>
            </div>
        </v-card-title>        
      </v-card>      
    </v-flex>    
    <v-dialog
        v-if="showNewCustomMap"
        :value="showNewCustomMap"        
        persistent
        scrollable >
        <v-card  >          
         <v-toolbar card>
            <v-toolbar-title>{{$t('Pilot.MapLayer.NewCustomLayer')}}</v-toolbar-title>   
             <v-spacer />
            <v-toolbar-items>              
              <v-btn icon small @click="showNewCustomMap = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar-items>         
        </v-toolbar>              
          <v-card-text>     
            <v-layout wrap>                                  
              <admin-map-layer-form :config="config" />
            </v-layout>  
          </v-card-text>    
           <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancelNewCustomLayer()" color="primary" flat >Cancel</v-btn>          
            <v-btn @click="saveNewCustomLayer()" color="primary" flat >Valid</v-btn>          
        </v-card-actions>    
        </v-card>
      </v-dialog> 
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  //@ts-ignore
  import draggable from 'vuedraggable'
  import Component from 'vue-class-component'
  import { Watch} from 'vue-property-decorator'  
  import { VuetifyConfirmObject } from 'vuetify-confirm'
  import { AloDbMapLayer } from '../../models/alodb/AloDbMapLayer'
  import apiMission from '@/api/mission'
  import AdminMapLayer from '@/components/admin/mapLayer/AdminMapLayer.vue'
  import AdminMapLayerForm from '@/components/admin/mapLayer/AdminMapLayerForm.vue'


  @Component({
    name: 'MissionDetailMapLayer',
    components:{draggable,AdminMapLayer,AdminMapLayerForm}    
  })
  export default class MissionDetailMapLayer extends Vue {  
    
    newExistingId = -1
    showNewCustomMap = false
    
    addingLayer = false
    removingLayer = false

    get config(){
      return {
        missionMode:true
      }
    }
    
    addNewCustomLayer() {
      this.$store.myActions.MAPLAYER_SELECT_DETAIL(-1).then(() => {
        this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
          LAY_SCOPE: "MIS",   
          ENS_ID: null,
          MIG_ID: null,
          MIS_ID: this.mission.misId,
          missionIds:[],
          missionGlobalIds:[],
        }).then(() => {
          this.showNewCustomMap=true
        })
      })
    }


    deleteCustomLayer(layer:AloDbMapLayer) {
      this.$confirm(this.$t('Pilot.MapLayer.DeleteCustomLayerDialogMessage').toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject).then(answer => {
        this.$store.myActions.MAPLAYER_DELETE_REQUEST(layer)
      })
    }

    editCustomLayer(layer:AloDbMapLayer) {
      this.$store.myActions.MAPLAYER_SELECT_DETAIL(layer.LAY_ID!).then(() => {
          this.showNewCustomMap=true
      })
    }

    saveNewCustomLayer() {
      this.$store.myActions.MAPLAYER_SAVE_REQUEST().then(() => {        
        this.showNewCustomMap=false
      })      
    }
    cancelNewCustomLayer() {
      this.$store.myActions.MAPLAYER_CANCEL_MODIFIED_ADM().then(() => {
        this.showNewCustomMap=false
      })      
    }


    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }    

    mounted() {
      
    }  

    get isOperator(){
      return this.$store.myGetters.isOperator
    }

    get isSysAdmin(){
      return this.$store.myGetters.isSysAdmin
    }

    get misEnsIds()
    {
      return this.mission?.ensId ?? undefined
    }

    get mapLayersById(){
      return this.$store.myGetters.mapLayersById
    }

    get existingLayers() {
      return this.$store.myGetters.mapLayers.filter(l => l.LAY_SCOPE != "MIS" && l.LAY_SCOPE != "MIG" &&  this.missionLayers.every(ml => l.id != ml.id)
                                                      && ((!this.isOperator && !this.isSysAdmin)  || this.misEnsIds == undefined || l.LAY_SCOPE != "ENS" || l.ENS_ID == this.misEnsIds))
    }
    
    get missionLayers() {      
      return this.$store.myGetters.mapLayers.filter(l => (l.LAY_SCOPE == "MIS" && l.MIS_ID == this.mission.misId) || 
                                                    (
                                                        l.LAY_SCOPE != "MIS" && l.MISSION_IDS!.some(id => id == this.mission.misId )
                                                        && ((!this.isOperator && !this.isSysAdmin)  || this.misEnsIds == undefined || l.LAY_SCOPE != "ENS" || l.ENS_ID == this.misEnsIds)
                                                    )
                                                  )
    }    

    get existingMissionLayers(){
      return this.missionLayers.filter(l => l.LAY_SCOPE != "MIS")
    }

    get customMissionLayers(){
      return this.missionLayers.filter(l => l.LAY_SCOPE == "MIS")
    }
   
    get mission() {
        return this.currentDetailMission.mission
    }

    async removeExistingLayer(layer:AloDbMapLayer) {
      if(!this.removingLayer) {
        this.removingLayer = true
        try{
          await apiMission.deleteMissionLayerLink(this.mission.misId!,layer.id!)
          //force la mise à jour en rerequetant l'item
          this.$store.myActions.MAPLAYER_SELECT_DETAIL_REQUEST(layer.id!)          
        }    
        finally{
          this.removingLayer = false
        }   
      }
    }

    async addNewExistingLayer() {
      if(!this.addingLayer) {        
        if(this.newExistingId > -1) {
          const layerId = this.newExistingId
          try{
            await apiMission.addMissionLayerLink(this.mission.misId!,layerId)
            //force la mise à jour en rerequetant l'item
            this.$store.myActions.MAPLAYER_SELECT_DETAIL_REQUEST(layerId)            
          }    
          finally{
            this.addingLayer = false
          }
        }
      }
    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .btnup{
    position: absolute;
    top:-6px;
    right:-7px;    
  }
  .btnup:hover{
    position: absolute;
  }
  .btndown{
    position: absolute;
    bottom:-6px;
    right:-7px; 
  }
  .btndown:hover{
    position: absolute;
  }

  
  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;
  }

  .position{
    position: absolute;
    top:0px;
    right:0px;
    bottom:0px;
    width:31px;
    background-color: #eee;
    display:flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;    
  }

  .disable{
    overflow: hidden!important;
    position: relative;
  }

 
  .disable::before{
    position: absolute;
    content: '';
    left:0px;    
    right:0px;
    top: 0px;
    height:8000%;
    background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

</style>
